import { SPEAK_STATUS } from '@/define/Live';
// import { LIVE_STATUS } from '@panda/cache/src/live/define';

export default {
  liveStatus: null,
  liveAccount: '',
  mine: {
    isTeacher: false,
    hasCamera: false,
    hasAudio: false,
  },
  teacher: {
    hasCamera: false,
  },
  classmates: [],
  teacherStatus: {
    playVideo: true,
    playAudio: true,
  },
  mySpeakStatus: {
    hasSpoken: false,
    speakStatus: SPEAK_STATUS.NORMAl,
  },
  allowSpeak: false,
  speaker: {
    hasCamera: false,
  },
  pushStatus: {
    isPushing: false,
  },
};
